export default __webpack_public_path__ + "static/media/alliance_im05.bc58ca30.png";